<template>
  <div class="mainr" v-if="comeing">
    <div class="title-img">
      <img src="/images/mentionMe/2.png" class="imgs-show-co" @click="del_history" />
      <div class="send-button" @click="popShowu">马上送姐妹</div>
      <div class="main-fu">
        <div class="sister-list" v-if="!receiveList.length&&!receiveList1.length">
          还没有姐妹领取你的代金券
          TA领取成功，你可得同样的券
          （每人仅限获得一张）
        </div>
        <div v-if="receiveList1.length==0&&receiveList.length">
          <div
            style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:30px;margin-top: 10px;"
            v-for="(f, index) in receiveList"
            v-bind:key="index"
          >
            <van-col span="4">
              <img class="avadar" :src="f.headImg||avader" alt />
            </van-col>
            <van-col span="6">
              <div style="text-align:left;line-height:20px" class="quan">{{f.nickName}}</div>
            </van-col>
            <van-col span="14">
              <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
            </van-col>
          </div>
        </div>
        <div v-if="receiveList1.length!=0">
          <div class="pop-zhe"></div>
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="5000"
            :stop-propagation="true"
            :show-indicators="false"
          >
            <van-swipe-item v-for="(obj, index) in receiveList1" v-bind:key="index">
              <div
                style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:40px"
                v-for="(f, index) in obj"
                v-bind:key="index"
              >
                <van-col span="4">
                  <img class="avadar" :src="f.headImg||avader" alt />
                </van-col>
                <van-col span="6">
                  <div style="text-align:left;line-height:20px" class="quan">{{f.nickName}}</div>
                </van-col>
                <van-col span="14">
                  <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
                </van-col>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <img src="/images/mentionMe/3.png" alt style="width:293px;margin:20px 0;" />
        <div class="sister-list-dl">
          已获得的券可在<span class="quan" @click="pageGo('/my/couponList?fromMrntion=true')">我的优惠券</span>里查看
          <!-- <router-link to="/my/couponList"> -->
          <!-- </router-link> -->
        </div>
      </div>
    </div>

    <img src="/images/mentionMe/1.png" class="imgs-show" @click="del_history" />
    <div class="main-bottun">
      <div style="height:200px;"></div>
      <div class="title-fij">
        <span>领限量大牌真皮发卡</span>
      </div>
      <div
        class="what-disc"
      >迪士尼出逃公主们都有一枚特别的发卡，当你的姐妹领取并使用了这张代金券，你和TA都可以获得一枚大牌真皮发卡（总量1000枚，每人限领一枚，先到先得），想和姐妹一起把发卡戴在头上酷美逛街吗？</div>
    </div>
    <div class="friend-list">
      <img src="/images/mentionMe/4.png" class="title-img-d" alt />
      <div
        class="sister-list"
        v-if="!receiveList2.length&&!receiveList22.length"
      >还没有好友使用过你分享的代金券TA使用后，你们各自都获得一个大牌真皮发卡（每人仅限获得一次）</div>
      <div v-if="receiveList22.length==0&&receiveList2.length">
        <div
          style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:30px;margin-top: 10px;"
          v-for="(f, index) in receiveList2"
          v-bind:key="index"
        >
          <van-col span="4">
            <img class="avadar" :src="f.headImg||avader" alt />
          </van-col>
          <van-col span="6">
            <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
          </van-col>
          <van-col span="14">
            <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
          </van-col>
        </div>
      </div>
      <div v-if="receiveList22.length!=0">
        <div class="pop-zhe"></div>
        <van-swipe vertical class="notice-swipe3" :autoplay="5000" :show-indicators="false">
          <van-swipe-item v-for="(obj, index) in receiveList22" v-bind:key="index">
            <div
              style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:40px"
              v-for="(f, index) in obj"
              v-bind:key="index"
            >
              <van-col span="4">
                <img class="avadar" :src="f.headImg||avader" alt />
              </van-col>
              <van-col span="6">
                <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
              </van-col>
              <van-col span="14">
                <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
              </van-col>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <img src="/images/mentionMe/3.png" alt style="width:293px;margin:0px 25px;" />
      <div id="add-adderss"></div>
      <tiwo-select-Address
        class="address"
        :sendFrom="fajiaAddress"
        @changeAdr="changeAdr"
        ref="setAdr"
      ></tiwo-select-Address>
      <!-- <div class="addess" v-if="fajiaAddress">
        <div class="title mabide">收货地址</div>
        <div style="height:50px">
          <van-col span="18">
            <div
              style="text-align:left;line-height:20px"
              class="mabide"
            >北京市朝阳区东亿国际传媒产业园三期c座6号门真有两把刷子</div>
          </van-col>
          <van-col span="6">
            <div class="test-icon">
              修改
              <img class="cions-ff" src="/images/mentionMe/right-icon.png" alt />
            </div>
          </van-col>
        </div>
        <div class="luokuan mabide">
          <span>收货地址</span>
        </div>
      </div>
      <div class="addess" v-if="!fajiaAddress">
        <div class="title mabide">收货地址</div>
        <div style="height:30px">
          <van-col span="18">
            <div
              style="text-align:left;line-height:20px"
              class="mabide"
            >你还没有收货地址</div>
          </van-col>
          <van-col span="6">
            <div class="test-icon">
              添加一个
              <img class="cions-ff" src="/images/mentionMe/right-icon.png" alt />
            </div>
          </van-col>
        </div>
      </div>-->
      <img src="/images/mentionMe/3.png" alt style="width:293px;margin:0px 25px;" />
      <div class="sister-list-dl-e">
        当好友使用代金券，包大人在给TA的好物进行养护服务时，我们会寄出赠送给你的这件礼品，所以请确保自己的<span class="quan" @click="pageGo('/my/address/list')">收货地址</span>正确哦！
        <!-- <router-link to="/my/address/list"> -->
        <!-- </router-link> -->
      </div>
    </div>
    <div style="margin-top:40px;padding-bottom: 40px;">
      <div class="title-fij">
        <span>活动规则</span>
      </div>
      <div v-bind:class="[isActive?'sister-list-dl-ffds ':'','sister-list-dl-fg']">
        <p>1、活动期间为 8月10日0:00 - 9月10日 24:00，被邀请的包拯用户可以参加一次限时分享活动，每人可以将66元包拯养护代金券（满300可用）分享给好友，好友（从未注册过包拯）领取代金券，发起人即可得到同等奖励（每人仅限一次）。</p>
        <p>2、接到邀请的用户可参加本次限时分享活动，活动期间登录活动页面，即可查看活动规则及活动奖励，并参与分享。</p>
        <p>3、只有包拯的新用户领取券后你才能获得奖励，所以活动发起后请尽快邀请好友，以免好友被其它人先邀请走。</p>
        <p>4、此次活动，你的朋友将会获得：</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;① 领券成功后可获得1张66元包拯全品类奢品养护代金券，领取后90天内可用。</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;②&nbsp; 领券并在有效期内使用该券，可获得一个手工改造大牌真皮发卡。</p>
        <p>5、此次活动，你将获得：</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;① 有一位好友（从未注册过包拯）领取了你分享的代金券，你即可获得1张66元包拯全品类奢品养护代金券，领取后90天内可用。</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;②&nbsp; 领券的好友中只要有一人使用该券，你即可获得一个手工改造大牌真皮发卡，此礼品每人仅限获得一次。</p>
        <p>6、优惠券使用时会默认选中抵扣金额最高的优惠券，优惠券不可叠加使用。</p>
        <p>7、同一个账号、同一个手机、同一个支付账号均视为同一用户。</p>
        <p>8、活动中设立的赠品，除得到奖励的老用户单独包邮寄回，其他情况均随养护品一起寄回。</p>
        <p>9、活动方可根据活动举办的实际情况，保持活动一切解释和调整权。</p>
        <p>10、对活动有任何疑问，请咨询您微信中的客服人员</p>
      </div>
      <p>
        <br />
      </p>
      <div class="show-or-less" @click="openRuls" v-if="isActive">
        <span>展开显示全部规则</span>
        <img src="/images/mentionMe/5.png" alt class="imgr" />
      </div>
      <div class="show-or-less" @click="openRuls" v-if="!isActive">
        <span>收起全部规则</span>
        <img src="/images/mentionMe/c5.png" alt class="imgr" />
      </div>
    </div>
    <div class="line-geli"></div>
    <div class="active-panel">
      <div class="title-fij">
        <span>活动动态</span>
      </div>
      <div v-if="showAlist2.length==0">
        <div
          style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:40px;margin-top: 10px;"
          v-for="(f, index) in activityList"
          v-bind:key="index"
        >
          <van-col span="4">
            <img class="avadar" :src="f.headImg||avader" alt />
          </van-col>
          <van-col span="6">
            <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
          </van-col>
          <van-col span="14">
            <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
          </van-col>
        </div>
      </div>
      <div v-if="showAlist2.length!=0">
        <div class="pop-zhe"></div>
        <van-swipe vertical class="notice-swipe2" :autoplay="5000" :show-indicators="false">
          <van-swipe-item v-for="(obj, index) in showAlist2" v-bind:key="index">
            <div
              style="margin:5px 20px;width:calc(100% - 40px);line-height:20px;height:40px"
              v-for="(f, index) in obj"
              v-bind:key="index"
            >
              <van-col span="4">
                <img class="avadar" :src="f.headImg||avader" alt />
              </van-col>
              <van-col span="6">
                <div style="text-align:left;line-height:20px">{{f.nickName}}</div>
              </van-col>
              <van-col span="14">
                <div style="text-align:left;line-height:20px;height:30px">{{f.showContent}}</div>
              </van-col>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="line-geli"></div>
    <div class="active-panel">
      <div class="sic-ldss">对活动有任何疑问</div>
      <div class="sic-ldss">请咨询微信中的包拯客服</div>
      <img src="/images/mentionMe/6.png" class="acid" alt @click="popShowd" v-if="!scrollTopFlag" />
      <img
        src="/images/mentionMe/6.png"
        class="acid fudong"
        alt
        @click="popShowd"
        v-if="scrollTopFlag"
      />
    </div>
    <div style="width:100%;height:50px"></div>
    <!-- <div class="yaopqing" v-if="shareFlag" @click="hidePop">
      
    </div>-->
    <van-popup position="top" closeable close-icon-position="top-left" v-model="shareFlag">
      <img src="/images/mentionMe/7.png" alt="xiaog" class="dfewf" />
    </van-popup>
  </div>
</template>

<script>
import publicObj from "@/assets/js/public";
import callmeApi from "@/axios/callme";
import wxShare from "@/assets/js/wx.share";
import { Toast } from "vant";
import zhugeObj from "@/assets/js/track";
const TIME_COUNT = 60;
export default {
  name: "sendIndex",
  data() {
    return {
      scrollTop: 0,
      scrollTopFlag: false,
      account: "",
      code: "",
      openId: "",
      isSelfPage: false,
      isActive: true,
      shareFlag: false,
      acClass: "sister-list-dl-fg",
      errorClass: "sister-list-dl-ffds",
      avader: "/images/mentionMe/default_avatar.92027116.png",
      isSendCodeFlag: false,
      reSendSecond: TIME_COUNT,
      checkRadio: true,
      autoLogin: false,
      fajiaAddress: null,
      receiveList: [],
      receiveList1: [],
      receiveList2: [],
      receiveList22: [],
      showAlist: [],
      showAlist11: [],
      showAlist1: [],
      showAlist2: [],
      getZuge:true,
      showAlist3: [],
      comeing: false,
      isIos: true,
      geterActivitys1: [],
      geterActivitys11: [],
      geterActivitys: [],
      goodsData: {
        goodsImageList: [
          "https://baozheng-front.oss-cn-beijing.aliyuncs.com/2020/03/26/e81a3be4-7498-4b94-bfdd-7e6e28500310.jpg"
        ]
      },
      activityList: [],
      submitImageList: []
    };
  },
  watch: {},
  computed: {
    token() {
      return this.$store.state.token;
    },
    customerId() {
      return localStorage.getItem("customerId");
    }
  },
  created() {

  },
  mounted() {
    zhugeObj.track({
      title : '提我-分享者页曝光',
    })
    const servicePhoneId =
      this.$route.query.servicePhoneId ||
      publicObj.GetQueryString("servicePhoneId") ||
      "0";
    setTimeout(()=>{
      let shareBody = {
        imgUrl:
          "https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG162.png",
        title: "一声姐妹大过天！奢品养护大礼包我送你！",
        desc: "一起领限量“大牌闺蜜发卡”吗？",
        link: window.location.origin +"/mentionMe/recipt-index?servicePhoneId=" +servicePhoneId +"&invitedCustomerId=" +localStorage.getItem("customerId")
        // link:
        //   "http://test.baozheng.cc/mentionMe/recipt-index?servicePhoneId=323"
      };
      wxShare(shareBody).then(()=>{
        zhugeObj.track({
          title : '提我 - 分享者页 “分享成功”曝光',
        })   
      });
    },2000)
    
    this.comeing = true;
    this.activityDynamic();
    this.receiveCouponList();
    this.selecteAddress();
    this.receiveCouponList2();

    let that = this;
    window.onscroll = () => {
      //为了保证兼容性，这里取两个值，哪个有值取哪一个
      //scrollTop就是触发滚轮事件时滚轮的高度
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if(this.getZuge&&scrollTop > 300){
        this.getZuge=false
        zhugeObj.track({
          title : '提我 - 领取者发卡曝光',
          content : {
            'customerId' :localStorage.getItem("customerId")
          }
        })
      }
      if (scrollTop > 400) {
        that.scrollTopFlag = true;
      } else {
        that.scrollTopFlag = false;
      }
      console.log(scrollTop)
    };
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
    document.body.appendChild(script);
    let dsf = {servicePhoneId: servicePhoneId,invitedCustomerId:localStorage.getItem("customerId")}
    setTimeout(()=>{
      wx.miniProgram.postMessage({ data: dsf })
    },1000)
  },
  methods: {
    changeAdr(e) {
      console.log(e);
      this.upAddAddress(e.id);
    },
    pageGo(url){
      window.history.pushState(
        null,
        null,
        "/mentionMe/send-index?isGoOut=1"
      );
      this.$router.push(url)
    },
    upAddAddress(id) {
      let parms = {
        invitedCustomerId: this.customerId,
        addressId: id
      };
      callmeApi.upAddAddress(parms).then(res => {
        this.fajiaAddress = res;
      });
    },
    showShade(e) {
      console.log(e);
    },
    selecteAddress() {
      let parms = {
        invitedCustomerId: this.customerId
      };
      callmeApi.selectInvitedAddress(parms).then(res => {
        this.fajiaAddress = res;
      });
    },
    popShowu() {
      zhugeObj.track({
        title : '提我-分享者转发顶部按钮点击',
      })
      // 点击跳转小程序页面
      wx.miniProgram.navigateTo({url: '/pages/goAnyWhere/index'})
      if (!this.fajiaAddress) {
        window.location.href = "#add-adderss";
        Toast("请添加收货地址！");
      } else {
        this.shareFlag = true;
      }
    },
    popShowd() {
      zhugeObj.track({
        title : '提我-分享者转发底部按钮点击',
      })
      if (!this.fajiaAddress) {
        window.location.href = "#add-adderss";
        Toast("请添加收货地址！");
      } else {
        this.shareFlag = true;
      }
    },
    hidePop() {
      this.shareFlag = false;
    },
    getgets() {
      callmeApi.receiveCouponList().then(res => {});
    },
    receiveCouponList() {
      let paras = {
        customerId: this.customerId
        // state: 10
      };
      callmeApi.receiveCouponList(paras).then(res => {
        let index = 0;
        let lenth = res ? res.length : 0;
        this.receiveList = res;
        let array1 = [];
        for (let i = 0; i < lenth - 2; i = i + 2) {
          let list = [];
          list.push(res[i]);
          i + 1 < lenth && list.push(res[i + 1]);
          i + 2 < lenth && list.push(res[i + 2]);
          array1.push(list);
        }
        this.receiveList1 = array1;
      });
    },
    receiveCouponList2() {
      let paras = {
        customerId: this.customerId,
        state: 20
      };
      callmeApi.receiveCouponList(paras).then(res => {
        let index = 0;
        let lenth = res ? res.length : 0;
        this.receiveList2 = res;
        let array1 = [];
        for (let i = 0; i < lenth - 2; i = i + 2) {
          let list = [];
          list.push(res[i]);
          i + 1 < lenth && list.push(res[i + 1]);
          i + 2 < lenth && list.push(res[i + 2]);
          array1.push(list);
        }
        this.receiveList22 = array1;
      });
    },
    activityDynamic() {
      callmeApi.activityDynamic().then(res => {
        let index = 0;
        this.activityList = res;
        let lenth = res ? res.length : 0;
        let array = [];
        for (let i = 0; i < lenth - 3; i = i + 3) {
          let list = [];
          list.push(res[i]);
          i + 1 < lenth && list.push(res[i + 1]);
          i + 2 < lenth && list.push(res[i + 2]);
          array.push(list);
        }
        this.showAlist1 = array;
        let array1 = [];
        for (let i = 0; i < lenth - 2; i = i + 2) {
          let list = [];
          list.push(res[i]);
          i + 1 < lenth && list.push(res[i + 1]);
          i + 2 < lenth && list.push(res[i + 2]);
          i + 3 < lenth && list.push(res[i + 3]);
          array1.push(list);
        }
        this.showAlist2 = array1;
      });
    },
    openRuls() {
      this.isActive = !this.isActive;
    },
    del_history() {
      console.log(333333);
    }
  }
};
</script>

<style scoped lang="scss">
// body {
//   overflow-x: hidden;
// }
.mainr {
  // position: fixed;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  background-color: rgba(222, 242, 242, 0.3);
}
.imgs-show {
  width: 100%;
}
.imgs-show-co {
  display: block;
  width: 686px;
}

.title-img {
  position: absolute;
  width: 686px;
  left: calc(50% - 343px);
  top: 4rem;
  z-index: 999;
}
.main-fu {
  padding: 0 40px;
  padding-top: 20px;
  height: 430px;
  background-color: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.send-button {
  width: 420px;
  height: 84px;
  background: #63bfbf;
  border-radius: 42px;
  position: absolute;
  left: calc(50% - 210px);
  top: 480px;

  font-size: 44px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fff;
  line-height: 84px;
  text-align: center;
}
img {
  vertical-align: top;
}
.sister-list-dl {
  position: relative;
  left: calc(50% - 215px);
  width: 430px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  padding: 40px 0 30px 0;
}
.sister-list-dl-fg {
  position: relative;
  left: 40px;
  width: calc(100% - 80px);
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  // font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}
.sister-list-dl-e {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;

  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  padding: 25px 50px 50px 50px;
}
.sister-list {
  position: relative;
  left: calc(50% - 190px);
  width: 380px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  padding: 50px 0;
  text-align: center;
}
.quan {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: #f56d6d;
}
.what-disc {
  width: calc(100% - 80px);
  padding: 0 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  text-align: left;
  line-height: 40px;
  padding-bottom: 40px;
}
.main-bottun {
  width: 100%;
}
.title-fij {
  margin: 40px 0 20px 0;
  width: 100%;
  text-align: center;
  height: 58px;
}
.title-fij span {
  font-size: 42px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 29px;
}
.friend-list {
  margin: 0 40px;
  width: calc(100% - 80px);
  background-color: #def2f2;
}
.title-img-d {
  width: 100%;
  height: 264px;
}
.show-or-less {
  text-align: center;
}
.show-or-less span {
  width: 112px;
  height: 20px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 166, 166, 1);
  line-height: 40px;
}
.imgr {
  width: 24px;
  height: 14px;
  vertical-align: middle;
  margin: 0 10px;
  position: relative;
  top: -2px;
}
.line-geli {
  width: 100%;
  height: 16px;
  background: rgba(212, 223, 223, 1);
}
.van-col {
  line-height: 72px;
  text-align: left;
}
.avadar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  position: relative;
  top: -15px;
}
.sic-ldss {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  text-align: center;
}
.sic-ldss span {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
}
.active-panel {
  padding: 50px;
}
.active-panel .acid {
  margin: 40px calc(50% - 210px);
  height: 84px;
  width: 410px;
}
.sister-list-dl-ffds {
  height: 220px;
  overflow: hidden;
  position: relative;
  left: 40px;
  width: calc(100% - 80px);
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  // font-weight: 700;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}
.yaopqing {
  position: absolute;
  z-index: 1000;
  background-color: #080808b5;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}
.dfewf {
  height: 5.78667rem;
  width: 7.28rem;
  margin-top: 100px;
  margin-left: calc(50% - 3.64rem);
}
.van-popup {
  background-color: rgba(0, 0, 0, 0);
}
.notice-swipe {
  height: 280px;
  line-height: 40px;
}
.notice-swipe2 {
  height: 350px;
}
.van-swipe-item {
  height: 80px;
}
.notice-swipe3 {
  height: 280px;
  padding-top: 20px;
}
.addess {
  padding: 20px 50px;
  div {
    margin: 5px 0;
  }
  .mabide {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    font-weight: 700;
  }
  .luokuan {
    text-align: left;
  }
}
.test-icon {
  text-align: right;
  line-height: 20px;
  height: 30px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(99, 191, 191, 1);
  line-height: 20px;
}
.cions-ff {
  width: 13px;
  height: 15px;
  position: relative;
  top: 13px;
}
.pop-zhe {
  width: calc(100% - 80px);
  height: 300px;
  z-index: 1234;
  position: absolute;
}
.fudong {
  position: fixed;
  bottom: 0px;
  left: 0;
}
#add-adderss {
  position: relative;
  top: -100px;
}
</style>
